<span
  class="status-badge leading-none"
  [class]="colorScheme() + ' ' + statusLowerCase() + ' ' + colorType()"
  [ngClass]="{
    '!text-[10px] !leading-3': size() === 'small' || size() === 'micro',
    'py-0.5': size() === 'small',
    'py-0': size() === 'micro',
    '!bg-transparent px-0': !hasHorizontalPadding(),
    'px-[8px]': hasHorizontalPadding() && (size() === 'small' || size() === 'micro'),
    'py-[3px] px-2': hasHorizontalPadding() && size() === 'medium',
    'py-[6px] px-3': hasHorizontalPadding() && size() === 'large',
  }"
>
  {{ 'shared.statuses.' + statusLowerCase() | translate }}
</span>

<span
  #defaultBackgroundProbe
  class="status-badge leading-none fixed opacity-0 pointer-events-none"
  [class]="colorScheme() + ' ' + statusLowerCase() + ' ' + colorType()"
></span>
